import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LocalStorageState = Record<string, any | undefined>;
type LocalStorageEntry<T = unknown> = { key: string; value: T | undefined };

const initialState: LocalStorageState = {};

export const localStorageSlice = createSlice({
  name: 'localStorage',
  initialState,
  reducers: {
    setValue: (state, { payload }: PayloadAction<LocalStorageEntry>) => {
      state[payload.key] = payload.value;
      if (typeof payload.value !== 'undefined') {
        localStorage.setItem(payload.key, JSON.stringify(payload.value));
      } else {
        localStorage.removeItem(payload.key);
      }
    },
  },
});

export const localStorageReducer = localStorageSlice.reducer;
export const localStorageActions = localStorageSlice.actions;
